import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Investor } from '../../shared/models/investor';
import { InvestorDataService } from '../../../core/investor-data.service';
import { User } from '../../../core/user';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../../core/auth.service';
import { ActivatedRoute } from '@angular/router';
import { tap } from 'rxjs/operators';
import { GoalDetailsComponent } from '../goal-details/goal-details.component';
import { InsuranceDetailsComponent } from '../insurance-details/insurance-details.component';
import { InvestorDetailsComponent } from '../investor-details/investor-details.component';
import { IncomeDetailsComponent } from '../income-details/income-details.component';
import { AssetDetailsComponent } from '../asset-details/asset-details.component';
import { BalanceComponent } from '../balance/balance.component';
import { ScoreCardComponent } from '../score-card/score-card.component';
import { connect } from 'tls';

@Component({
  selector: 'app-checkup',
  templateUrl: './checkup.component.html',
  styleUrls: ['./checkup.component.css', './steps.css'],
})
export class CheckupComponent implements OnInit {
  state: any;
  stateOrder = [
    { type: 'inv_details', label: 'Investor Details' },
    { type: 'inc_details', label: 'Income Details' },
    { type: 'ins_details', label: 'Insurance Details' },
    { type: 'asset_details', label: 'Asset Details' },
    { type: 'asset_allocation', label: 'Asset Allocation' },
    { type: 'balance_details', label: 'Balance Details' },
    { type: 'goal_details', label: 'Goal Details' },
    { type: 'score_card', label: 'Score Card' },
  ];
  currentPosition: number;
  investor: Investor;
  user: Investor;
  currentUserData: User;
  currentUser: Observable<User>;
  customLabel: String;
  assetsLabel: boolean;
  liabilitiesLabel: boolean;
  flags: any = {};

  @ViewChild('InvDetails')
  InvDetails: InvestorDetailsComponent;
  @ViewChild('InsDetails')
  InsDetails: InsuranceDetailsComponent;
  @ViewChild('IncomeDetails')
  IncomeDetails: IncomeDetailsComponent;
  @ViewChild('AssetDetails')
  AssetDetails: AssetDetailsComponent;
  @ViewChild('Balance')
  Balance: BalanceComponent;
  @ViewChild('GoalPage')
  GoalPage: GoalDetailsComponent;
  @ViewChild('ScoreCard')
  ScoreCard: ScoreCardComponent;

  constructor(
    private ids: InvestorDataService,
    private auth: AuthService,
    private Activatedroute: ActivatedRoute,
  ) {
    this.customLabel = '';
  }

  ngOnInit() {
    this.currentPosition = 0;
    this.state = this.stateOrder[0];
    this.getCurrentUser();
    // const iid = this.Activatedroute.snapshot.params['iid'];
    // if (iid && iid.length > 0) {
    //   this.getInvestor(iid);
    // } else {
    //   this.investor = new Investor();
    //   this.investor.profession = 'job';
    //   if(!(this.currentUserData.roles.superAdmin || this.currentUserData.roles.admin || this.currentUserData.roles.editor)){
    //     this.investor.email = this.currentUserData.email;
    //     console.log("here");
    //   }
    //   if(this.currentUserData && this.currentUserData.displayName && this.currentUserData.displayName.length >=0 ){
    //     this.investor.RAName = this.currentUserData.displayName;
    //     console.log(1);
    //   } else {
    //     console.log(2);
    //   }
    // }

    // this.state = {'type': 'ins_details', 'label': 'Insurance Details'};
  }

  previousState() {
    if (this.state.type === 'goal_details') {
      this.GoalPage.updateInvestorGoals();
      console.log('nextState', 'here2');
    }
    var flag = false;
    switch (this.currentPosition) {
      case 0:
        if (
          confirm(
            'Are you sure you want to go back. Unsaved Data will be lost if you press yes',
          )
        ) {
          window.history.back();
        }
        break;
      case 3:
        console.log('Assets');
        if (!this.AssetDetails.moveBack()) {
          flag = true;
          this.assetsLabel = true;
          this.liabilitiesLabel = false;
        }
        break;
      default:
        break;
    }
    if (flag) {
      return;
    }
    this.assetsLabel = false;
    this.liabilitiesLabel = false;
    this.currentPosition = this.stateOrder.indexOf(this.state);
    if (this.currentPosition > 0) {
      this.currentPosition = this.currentPosition - 1;
      this.state = this.stateOrder[this.currentPosition];
    }
  }

  nextState() {
    this.currentPosition = this.stateOrder.indexOf(this.state);
    console.log(this.currentPosition);
    var flag = false;
    switch (this.currentPosition) {
      case 0:
        if (!this.InvDetails.validateBeforeExit()) {
          flag = true;
        }
        break;

      case 2:
        console.log('Insurance');
        if (!this.InsDetails.validateBeforeExit()) {
          flag = true;
        }
        break;

      case 3:
        console.log('Assets');
        if (!this.AssetDetails.moveNext()) {
          flag = true;
          this.liabilitiesLabel = true;
          this.assetsLabel = false;
        }
        break;
      case 6:
        this.GoalPage.updateInvestorGoals();
        break;

      default:
        break;
    }
    if (flag) {
      return;
    }
    this.assetsLabel = false;
    this.liabilitiesLabel = false;
    if (this.currentPosition < this.stateOrder.length - 1) {
      this.currentPosition = this.currentPosition + 1;
      this.state = this.stateOrder[this.currentPosition];
    }
    if (this.state.type === 'score_card') {
      this.GoalPage.updateInvestorGoals();
    }
    console.log('SAVING', 'HERE');
    if (this.investor.iid && this.investor.iid.length > 0) {
      console.log('edit investor', this.investor);
      this.editInvestor();
    } else {
      this.addInvestor();
    }
    // console.log(this.investor);
  }
  addInvestor() {
    if (!this.currentUserData) {
      console.log('user field empty');
      return;
    }
    // this.user = {
    //   iid: 'iid',
    //   createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    //   creatorId: this.currentUserData.uid,
    //   personName: this.investor.name,
    //   status: status.new,
    //   updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    //   values: this.investor
    // };
    // console.log('add', this.user);
    this.investor.creatorId = this.currentUserData.uid;
    this.ids.addInvestorData(this.investor);
  }
  editInvestor() {
    this.ids.editInvestorData(this.investor);
  }
  getCurrentUser() {
    this.currentUser = this.auth.getCurrentUser();

    this.currentUser.subscribe(
      (done) => {
        this.currentUserData = done;
        const iid = this.Activatedroute.snapshot.params['iid'];
        if (iid && iid.length > 0) {
          this.getInvestor(iid);
        } else {
          this.investor = new Investor();
          this.investor.profession = 'job';
          if (
            !(
              this.currentUserData.roles.superAdmin ||
              this.currentUserData.roles.admin ||
              this.currentUserData.roles.editor
            )
          ) {
            this.investor.email = this.currentUserData.email;
          }
          if (
            this.currentUserData &&
            this.currentUserData.displayName &&
            this.currentUserData.displayName.length >= 0
          ) {
            this.investor.RAName = this.currentUserData.displayName;
            console.log(1);
          } else {
            console.log(2);
          }
        }

        this.currentUserData = done;
        console.log('DONE', done);
        if (this.investor.RAName.length <= 0) {
          this.investor.RAName = done.displayName;
        } else {
        }
      },
      (error) => {
        console.log('Error value', error);
      },
      () => {
        console.log('finished');
      },
    );
  }
  setLabel(label) {
    this.customLabel = label;
    console.log(this.customLabel);
  }
  getInvestor(iid: string) {
    this.ids
      .getInvestorByKey(iid)
      .get()
      .then((value) => {
        this.investor = new Investor(value.data());
        console.log(this.investor);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/checkup/checkup.component.ts